import darknetImage from './image.png';
import DarknetImporterApp from './App.vue';

export var appConfig = {
	id: "frontend-darknet-importer",
	name: "darknet-importer",
	version: "1.2.0",
	hash: "",
	type: "importer",
	title: "Darknet Importer",
	author: "Au-Zone Technologies",
	docs: "https://doc.edgefirst.ai/latest/datasets/tutorials/import/#import-darknet-datasets",
	description: "Import Darknet datasets (images and text files) containing bounding box or segmentation annotations into EdgeFirst Studio.",
	date: new Date().toISOString(),
  	runs: 0,
	price: 0,
	image: darknetImage,
	component: DarknetImporterApp,
	actionLabel: 'Start Import',
	permission: "",
	is_hidden: false,
	user_launchable: true,
};